import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, withLatestFrom } from 'rxjs';
import { catchError, exhaustMap, mergeMap } from 'rxjs/operators';
import { EmissionPointsService, EmissionPointsWithParametersView, ParameterType } from '../../_generated';
import { EmissionPointsRequestStatusAction } from '../actionstypes/emission-points/emission-points-request-status.actiontype';
import * as EmissionPointsAction from '../actionstypes/emission-points/emission-points.actiontype';
import { RequestStatusAction } from '../actionstypes/request-status/request-status.actiontype';
import * as EmissionPointIdAction from '../actionstypes/selected-id/emission-point-id.actiontype';
import { DataEntryStore } from '../reducers/data-entry.reducer';
import { getDataType } from '../selectors/data-type.selector';
@Injectable()
export class EmissionPointsEffect {
  private readonly actions$ = inject(Actions);
  private readonly emissionPointsService = inject(EmissionPointsService);
  private readonly store = inject<Store<DataEntryStore>>(Store);

  loadEmissionPoints$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EmissionPointsAction.EmissionPointsAction.Load),
      withLatestFrom(this.store.select(getDataType)),
      exhaustMap(([, dataType]: [EmissionPointsAction.Load, ParameterType]) =>
        this.emissionPointsService.emissionPointsControllerFindAll(false, dataType).pipe(
          mergeMap((emissionPoints: EmissionPointsWithParametersView[]) => [
            new EmissionPointIdAction.Sync(emissionPoints.map((emissionPoint) => emissionPoint.id)),
            new EmissionPointsAction.Get(emissionPoints),
          ]),
          catchError((error) => of(new RequestStatusAction(EmissionPointsRequestStatusAction.Error, error as Error))),
        ),
      ),
    ),
  );

  successRequestEmissionPoints$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EmissionPointsAction.EmissionPointsAction.Get),
      mergeMap(() => of(new RequestStatusAction(EmissionPointsRequestStatusAction.Success))),
    ),
  );
}
